export const tw = {
  Navbar: {
    about_TOEIC: '測驗簡介',
    must_know_vocabulary: '必考單字'
  },
  Overview: {
    classify: '學前測驗',
    time: '學習總時數',
    course: '通過課程數',
    practice: '通過課後挑戰',
    exam: '完成月考數',
    exam_score: '月考分數',
    exam_advance: '任一月考>學前測驗',
    exam_advance_with_percent: '月考進步百分比'
  },
  Login: {
    register: '我要報名',
    trial: '申請試用',
    login: '登入',
    start_my_course: '登入學習'
  },
  Home: {
    Daily_English: '每日一句',
    World_News: '全球新聞',
    Lets_play_in_English: '英文好好玩',
    FunEnglish: '跟著老師一起，玩遊戲、學單字、培養英語語感力!',
    Learning_History: '近期學習課程',
    Latest_Courses: '最新課程',
    Recommend: '推薦課程',
    Learning_Guides: '學習指引',
    Go_to_course: '前往課程',
    Play: '播放音檔',
    Keep: '收藏',
    watch_more: '看更多'
  },
  Personal: {
    Info: {
      Total_study_time: '學習時數',
      Number_of_courses_passed: '通過課數',
      Number_of_monthly_exams: '月考次數',
      First_time_login: '首次登入'
    },
    Target: {
      Goal: '目標',
      Result: '結果',
      Completed: '已完成',
      Marks: '分',
      Unit: '課',
      Time: '次'
    },
    Record: {
      Learning_records: '學習紀錄',
      View_all: '總覽',
      Date_settings: '日期區間',
      Learning_hours: '學習時數',
      Number_of_completed_courses: '完成課數',
      Number_of_unit_tests_passed: '通過課後挑戰數',
      Details: '詳細內容',
      Course_categories: '課程分類',
      History: '最近學習時間',
      Unit_test_score: '單元測驗分數',
      Go_to_course: '前往課程'
    },
    Collection: {

    },
    Exam: {
      Exam: '測驗專區',
      Placement_test: '學前測驗',
      Result: '分級結果',
      Exam_date: '測驗日期',
      Answering_time: '作答時間',
      Listening_score: '聽力成績',
      Reading_score: '閱讀成績',
      Total_score: '總分',
      Monthly_mock_test: '每月模考',
      More_practice: '更多練習',
      Updated_exam_date: '最近測驗日期',
      Number_of_exercises: '練習次數',
      Start: '開始',
      Details: '詳解'
    }
  }
}
